<template>
  <div>
    <img
      src="../../../public/images/icons/mytrip.svg"
      alt="My Trip logo"
      class="mytrip-logo"
    />
    <div class="no-map-details">
      <div>
        <div class="default-message-title">
          Something was lost in translation
        </div>
        <div class="default-message-content">
          Oh no! It seems like your adventure-seeking compass has led you to
          uncharted territory. Don't worry; we're here to help<br />
          you find your ideal destination.
        </div>
      </div>
      <div>
        <div class="filter-message-title">Adjust Your Filter Options</div>
        <div class="filter-message-content">
          It's possible that your current filter settings are a bit too
          specific. Consider broadening your filter options or expanding your
          search area to unlock a world of possibilities. Try different
          combinations of filters to tailor your search to your heart's desire.
        </div>
      </div>
    </div>
    <div class="feedback-section">
      <Feedback />
    </div>
  </div>
</template>

<script>
export default {
  name: 'map-details-empty-state',
};
</script>

<style lang="scss" scoped>
.mytrip-logo {
  width: 74px;
  height: 74px;
  margin-top: 60px;
}
.no-map-details {
  width: 327px;
  margin: 0 auto;
  margin-top: 23px;
  @media only screen and (min-width: 897px) {
    width: 464px;
  }
}
.default-message-title {
  font-family: 'klinicslabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  color: #1a3138;
  width: 305px;
  height: 96px;
  margin: 0 auto;
  margin-bottom: 15px;
}
.default-message-content {
  font-family: 'IdealSans-Book';
  font-style: normal;
  font-weight: 325;
  font-size: 15px;
  line-height: 21.6px;
  color: #000000;
  width: 315px;
  height: 56px;
  margin-bottom: 70px;

  @media only screen and (min-width: 897px) {
    width: 464px;
    margin-bottom: 40px;
  }
}
.filter-message-title {
  font-family: 'klinicslabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 26px;
  color: #000000;
  height: 26px;

  @media only screen and (min-width: 897px) {
    width: 464px;
    height: 26px;
  }
}
.filter-message-content {
  font-family: 'IdealSans-Book';
  font-style: normal;
  font-weight: 325px;
  font-size: 13.85px;
  line-height: 19.2px;
  color: #000000;
  height: 76px;
  margin-bottom: 70px;

  @media only screen and (min-width: 897px) {
    width: 464px;
    margin-bottom: 40px;
  }
}
.feedback-section {
  @media only screen and (min-width: 897px) {
    margin-top: -4em;
  }
}
</style>
